import { isFile, isImage } from '../elements/utils/elementTypeUtils';
import { getFileProp } from '../elements/utils/elementPropertyUtils';

export const boardMediaFilter = (descendant) => (isFile(descendant) && getFileProp(descendant)) || isImage(descendant);
